import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { A } from '@adornis/base/env-info.js';

@Entity()
export class PartnerSchedulingClientRecord extends MongoEntity {
  static override _class = 'PartnerSchedulingClientRecord';
  static override _collectionName = 'partner-scheduling-clients';

  static override resolveID(_entity: PartnerSchedulingClientRecord): string {
    return (_entity._id ??= A.getGloballyUniqueID());
  }

  @Field(() => String, { default: v => v ?? A.getGloballyUniqueID() })
  override _id!: string;

  @Field(() => String)
  clientName: Maybe<string>;

  @Field(() => String)
  clientKey: Maybe<string>;

  @Field(() => String)
  region: Maybe<string>;

  @Field(() => String)
  country: Maybe<string>;

  @Field(() => String)
  requiredSla: Maybe<string>;

  @Field(() => String)
  city: Maybe<string>;

  @Field(() => String)
  address: Maybe<string>;

  @Field(() => String)
  zipCode: Maybe<string>;

  @Field(() => [String])
  partners: Maybe<string[]>;
}
